export default __webpack_public_path__ + "static/media/SeekPng.534d1410.svg";